import { createSlice } from '@reduxjs/toolkit';

const brokerSlice = createSlice({
  name: 'broker',
  initialState: {
    brokerId: null,
  },
  reducers: {
    setBrokerId: (state, action) => {
      state.brokerId = action.payload;
    },
  },
});

export const { setBrokerId } = brokerSlice.actions;

export default brokerSlice.reducer;
